<div>
  <div class="flex-between"> 
  <i class="fa-regular fa-xmark w-24px dialog-close-icon" id="btn_AssetsClose" [pTooltip]="translate?.general.buttons.close.singular" tooltipPosition="left"  (click)="closeAsset()"></i>
  </div>
  <div class="position-relative text-start">
    <span class="title" id="label_AssetsSelectFromList">{{translate?.general.commonComponent.sections.sec2.singular}}</span>
    <div class="flex-align-center mt-2">
      <span class="p-input-icon-left w-100 py-2">
        <i class="pi pi-search"></i>
        <input type="text" class="w-100" pInputText autocomplete="off" id="input_AssetsSelectFromListField" [placeholder]="translate?.general.buttons.search.singular" [(ngModel)]="searchValue"/>
      </span>
    </div>
    <div class="height-42-stat border" *ngIf="translate">
      <app-asset-table  [filterData]="filterData" [siteId]="siteId" [customerId]="customerId" [projectId]="projectId" [translate]="translate" [lookupFilter]="lookupFilter" [serviceZoneName]="serviceZoneName" [searchValue]="searchValue" [eligibleParentAssets]="eligibleParentAssets" [eligibleChildAssets]="eligibleChildAssets" [assetsIgnoreId]="assetsIgnoreId"></app-asset-table>
    </div>
  </div>
</div>